/*var Base = require('../common/base.js');
var getQueryStr = Base.getQueryStr;*/
import * as StringUtil from '../base/string.js';

import Dom from '../base/mdom.js';
import Env from '../common/env';

let exportData;
if(!Env.isCSR) {
    (function (win, doc) {

        var _isUseClick = window.__wxjs_is_wkwebview === 'yes' || window.__wxjs_is_wkwebview
                        || Dom.window.__wxjs_is_wkwebview === 'yes' || Dom.window.__wxjs_is_wkwebview
                        || Dom.window.navigator.userAgent.indexOf('WindowsWechat')  != -1;



        function checkStyle(_UI) {
            // var protocol = location.protocol,
            //     styleHref = 'wximg.qq.com/tmt/game/dist/css/wgui.1.0.1.min.css?max_age=2592000',
            //     links = document.getElementsByTagName('link'),
            //     isreged = false;
            // for (var i = 0, len = links.length; i < len; i++) {
            //     var _link = links[i].getAttribute('href');
            //     if (-1 != _link.indexOf('wgui') || -1 != _link.indexOf('wui')) {
            //         isreged = true;
            //         break;
            //     }
            // }
            // /*
            //  *   如果没有注册样式。则注入一下。支持https
            //  */
            // if (false === isreged) {
            //     var styleLink = document.createElement('link');
            //     styleLink.setAttribute('rel', "stylesheet");
            //     styleLink.setAttribute('href', protocol + '//' + styleHref);
            //     var head = document.getElementsByTagName('head')[0];
            //     head.appendChild(styleLink);
            //     isreged = true;
            // }

            var dialogDom = document.getElementById('new_dialog_alert');
            if(!dialogDom) {
                var dom = document.createElement('style');
                dom.setAttribute('type', "text/css");
                dom.setAttribute('id', "new_dialog_alert");

                var style = `
    .pagination {
        display: inline-block;
        padding-left: 0;
        margin: 20px 0;
        border-radius: 4px;
    }

    .pagination li {
        display: inline;
    }

    .wgui-alert-dialog__main {
        position: fixed;
        top: 50%;
        left: 50%;
        z-index: 100003;
        min-width: 320px;
        max-width: 330px;
        background-color: #fafafc;
        color: #000;
        text-align: center;
        font-size: 16px;
        border-radius: 8px;
        overflow: hidden;
        background-clip: padding-box;
        -webkit-transform: translate(-50%,-50%);
        -ms-transform: translate(-50%,-50%);
        transform: translate(-50%,-50%)
    }
    .wgui-alert-dialog__main.wgui-alert-dialog__border-radius {
        border-radius: var(--wg_border_radius_modal);
    }
    .wg_dark_mode .wgui-alert-dialog__main {
        background-color: #232323;
        color: rgba(255,255,255,0.8);
    }

    .wgui-alert-dialog__mask {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 100003;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,.6)!important;
        filter: progid:DXImageTransform.Microsoft.gradient(GradientType=0,startColorstr="#99000000",endcolorstr="#99000000")
    }

    .wgui-alert-dialog__header {
        padding: 20px 20px 0
    }

    .wgui-alert-dialog__title {
        margin-bottom: 10px;
        font-size: 20px;
        color: #353535;
        font-family: PingFangSC-Medium;
        line-height: 20px;
        margin-top: 12px;
    }
    .wg_dark_mode .wgui-alert-dialog__title {
        color: rgba(255,255,255,0.8);
    }

    .wgui-alert-dialog__body {
        overflow: hidden
    }

    .wgui-alert-dialog__content {
        box-sizing: border-box;
        margin-bottom: 20px;
        padding: 12px 24px;
        width: 100%;
        line-height: 24px;
        font-size: 17px;
        letter-spacing: -0.22px;
        text-align: center;
        opacity: 0.5;
        font-family: PingFangSC-Regular;
        color: #000000;
    }
    .wg_dark_mode .wgui-alert-dialog__content {
        opacity: 1;
        color: rgba(255,255,255,0.5);
    }

    .wgui-alert-dialog__content_left {
        text-align: left
    }

    .wgui-alert-dialog__footer {
        position: relative;
        display: -webkit-box
    }

    .wgui-alert-dialog__footer:after {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 1px;
        border-top: 1px solid #d5d5d6;
        content: " ";
        -webkit-transform: scaleY(.5);
        -ms-transform: scaleY(.5);
        transform: scaleY(.5);
        -webkit-transform-origin: 0 0;
        -ms-transform-origin: 0 0;
        transform-origin: 0 0
    }
    .wg_dark_mode .wgui-alert-dialog__footer:after {
        border-top-color: rgba(255,255,255,0.05);
    }

    .wgui-alert-dialog__btn {
        position: relative;
        display: block;
        width: 0;
        height: 56px;
        color: #353535;
        text-decoration: none;
        font-family: PingFangSC-Medium;
        font-size: 17px;
        letter-spacing: 1px;
        text-align: center;
        -webkit-box-flex: 1;
        display: flex;
        align-items: center;
        justify-content:center;
    }
    .wg_dark_mode .wgui-alert-dialog__btn {
        color: rgba(255,255,255,0.8);
    }

    .wgui-alert-dialog__btn:after {
        position: absolute;
        top: 0;
        left: 0;
        width: 1px;
        height: 100%;
        border-left: 1px solid #d5d5d6;
        content: " ";
        -webkit-transform: scaleX(.5);
        -ms-transform: scaleX(.5);
        transform: scaleX(.5);
        -webkit-transform-origin: 0 0;
        -ms-transform-origin: 0 0;
        transform-origin: 0 0
    }
    .wg_dark_mode .wgui-alert-dialog__btn:after {
        border-left-color: rgba(255,255,255,0.05);
    }

    .wgui-alert-dialog__btn:first-child:after {
        display: none
    }

    .wgui-alert-dialog__btn:active {
        background-color: #f2f2f2;
    }
    .wg_dark_mode .wgui-alert-dialog__btn:active {
        background-color: #2f2f2f;
    }

    .wgui-alert-dialog__btn_current {
        color: #576B95;
    }
    .wg_dark_mode .wgui-alert-dialog__btn_current {
        color: #7d90a9;
    }

    .wgui-alert-dialog__captcha-box {
        margin-bottom: 10px;
        text-align: center
    }

    .wgui-alert-dialog__captcha-img {
        display: block;
        margin: 0 auto 15px;
        width: 140px;
        height: 40px
    }

    .wgui-alert-dialog__captcha-input {
        margin-bottom: 10px;
        height: 39px;
        border: 1px solid #dfdfdd;
        text-align: center;
        line-height: 39px
    }

    .wgui-alert-dialog__captcha-tips {
        padding: 0 10px;
        color: #bb0b05;
        font-size: 14px
    }

    .wgui-alert-dialog_without-title .wgui-alert-dialog__title {
        display: none
    }

    .wgui-alert-dialog_without-title .wgui-alert-dialog__content {
        color: #000;
        opacity: 0.9;
        font-family: PingFangSC-Medium;
    }
    .wg_dark_mode .wgui-alert-dialog_without-title .wgui-alert-dialog__content {
        color: rgba(255,255,255,0.8);
        opacity: 1;
        font-family: PingFangSC-Medium;
    }

    .wgui-alert-dialog_single-line .wgui-alert-dialog__content {
        color: #000;
        opacity: 0.5;
    }
    .wg_dark_mode .wgui-alert-dialog_single-line .wgui-alert-dialog__content {
        color: rgba(255,255,255,0.5);
        opacity: 1;
    }

    .wgui-alert-dialog_captcha .wgui-alert-dialog__title {
        font-size: 18px;
        margin-bottom: 10px
    }
    `

                dom.innerHTML = style;
                var head = document.getElementsByTagName('head')[0];
                head.appendChild(dom);
            }

            return true;
        }
        var StyleStrMap = {
            tpl: [
                //wgui-alert-dialog_without-title
                '<div class="wgui-alert-dialog {titleClass} {singleLineClass} {customClass}">',
                '    <div class="wgui-alert-dialog__mask"></div>',
                '    <div class="wgui-alert-dialog__main wgui-alert-dialog__border-radius">',
                '        <div class="wgui-alert-dialog__header">',
                '            <div class="wgui-alert-dialog__title">',
                '                {title}',
                '            </div>',
                '        </div>',
                '        <div class="wgui-alert-dialog__body">',
                '            <div class="wgui-alert-dialog__content {isLeftClass} {isSmallClass}" style="{appendStyle}" >',
                '                {content}',
                '            </div>',
                '        </div>',
                '        <div class="wgui-alert-dialog__footer">',
                '            <!--底部按钮支持 1 & 2 个数量-->',
                '            <!--添加 wgui-alert-dialog__btn_current 高亮-->',
                '            <a href="javascript:;" class="wgui-alert-dialog__btn"  id="close_{gid}" style="display:{btnStyle}">{closeTxt}</a>',
                '            <a href="javascript:;" class="wgui-alert-dialog__btn wgui-alert-dialog__btn_current" id="confirmTxt_{gid}">{confirmTxt}</a>',
                '        </div>',
                '    </div>',
                '</div>'
            ],
        };

        (function (ui) {
            function addEvent(_aoDomTarget, _asType, _afHandlerCallback) {
                if (_aoDomTarget.addEventListener) {
                    _aoDomTarget["addEventListener"](
                        _asType, _afHandlerCallback, false
                    );
                } else if (_aoDomTarget.attachEvent) {
                    _aoDomTarget["attachEvent"]("on" + _asType,
                        _afHandlerCallback
                    );
                } else {
                    _aoDomTarget["on" + _asType] = _afHandlerCallback;
                }
            }

            var styleReged = false,
                layer = [];

            var _ajustPos = function (dialog) {
                dialog.style.marginTop = '-' + (parseInt(dialog.offsetHeight) / 2) + 'px';
            };
            var _closeAlert = function () {
                var _o = layer.pop();
                if (!_o) {
                    return;
                }

                if(_isUseClick){
                    _o.confirmObj.removeEventListener('click', _o.confirmHander, false);
                    _o.closeObj.removeEventListener('click', _o.closeHander, false);
                }else{
                    _o.confirmObj.removeEventListener('touchend', _o.confirmHander, false);
                    _o.closeObj.removeEventListener('touchend', _o.closeHander, false);
                }
                _o.confirmObj = null;
                _o.closeObj = null;

                // _o.confirmObj.removeEventListener('touchend', _o.confirmHander, false);
                // _o.confirmObj = null;

                // _o.closeObj.removeEventListener('touchend', _o.closeHander, false);
                // _o.closeObj = null;
                document.body.removeChild(document.getElementById(_o.name));

            };

            var _alert = function (str, cfg) {
                cfg = cfg || {};

                var defaultCfg = {
                    name: 'name_' + (new Date()).getTime(),
                    icon: '',
                    alertStr: '',
                    title: '',
                    content: '',
                    noticeTxt: '',
                    confirmTxt: '确定',
                    isLeft: false,
                    confirmCb: function () {},
                    closeTxt: '取消',
                    closeCb: function () {},

                    openCb: function () {},
                    calller: window,
                    closeAfterClick: true,
                    style: 'oneBtn',
                    zoom: false,
                    needScroll: false,
                    isSmallClass:  false,
                    isContentDividedIntoUL: false,
                    isSingleLine: true,
                    customClass: ''
                };
                /*
                *   做一下兼容防止传入错误参数
                */
                for (var p in defaultCfg) {
                    if (!(p in cfg)) {
                        cfg[p] = defaultCfg[p];
                    }
                }
                if (false == checkStyle(ui)) {
                    return;
                }

                cfg.alertStr = str || cfg.alertStr;

                if ( cfg.isContentDividedIntoUL ) {
                    var pureContent = cfg.alertStr.replace(/(^|\n)\d\./g, '');

                    cfg.content = pureContent.replace(/[^\n]+/g, function(replaced, offset) {

                        if ( replaced === '\n' ) {
                            return '';
                        }

                        return '<li>' + replaced + '</li>'
                    })
                    cfg.content = '<ul>' + cfg.content + '</ul>';
                } else {
                    cfg.content = (cfg.alertStr + '').replace(/\n/g, '<br/>');
                }

                // cfg.singleLineClass =  cfg.isSingleLine ? 'wgui-alert-dialog_single-line' : ''
                cfg.singleLineClass = '';

                if (cfg.code) {
                    cfg.content += '<span style="color: rgba(128,128,128,0.1);font-size: 0.6em;margin-top: -0.3em;display: block;position: absolute;bottom: 4.2em;right: 3px;">' + cfg.code + '</span>';
                }
                cfg.title = cfg.title || cfg.noticeTxt;
                cfg.titleClass = typeof cfg.title != 'undefined' && cfg.title.length > 0 ? '' : 'wgui-alert-dialog_without-title';
                if (!(cfg.style in {
                        'oneBtn': 1,
                        'twoBtn': 1
                    })) {
                    alert('style invalid');
                    return;
                }
                cfg.btnStyle     = cfg.style == 'oneBtn' ? 'none' : '';
                cfg.isLeftClass  = cfg.isLeft === true ? 'wgui-alert-dialog__content_left' : '';
                cfg.isSmallClass = cfg.isSmallClass === true ? 'wgui-alert-dialog__content_small' : '';
                cfg.isContentDividedIntoUL = cfg.isContentDividedIntoUL === true;
                cfg.appendStyle  = cfg.needScroll ? 'max-height: 270px; overflow-y: scroll; text-align: left; word-break: break-word' : '';
                var wrap = document.createElement('div'),
                    wndid, _tpl, alertName = cfg.name,
                    nameAlertMap = {};

                if (Env.isDarkMode) {
                    wrap.classList.add(`wg_dark_mode`)
                }
                /*
                *  定义模板
                */

                _tpl  = StyleStrMap.tpl;
                wndid = '__alert__' + (new Date()).getTime() + '__' + parseInt(Math.random() * 100);
                wrap.id = wndid;
                cfg.gid = wndid;
                var tpl = (_tpl.join('')).replace(/\{(\w+)\}/g, function (m, n) {
                    return cfg[n] !== undefined ? cfg[n].toString() : m;
                });
                if (cfg.zoom && window.Bigger) {
                    setTimeout(function () {
                        Bigger(wrap, 320, true);
                    }, 30);
                }

                StringUtil.insertHTMLFilterXss(tpl,wrap,true);

                document.body.appendChild(wrap);

                //再添加点击事件
                var _ids = {
                    iconObj: document.getElementById('icon_' + wndid),
                    alertObj: document.getElementById('alertStr_' + wndid),
                    confirmObj: document.getElementById('confirmTxt_' + wndid),
                    closeObj: document.getElementById('close_' + wndid)
                };
                if (cfg.showClose == false) {
                    _ids.closeObj ? _ids.closeObj.style.display = 'none' : '';
                }
                if (cfg.showIcon == false) {
                    _ids.iconObj ? _ids.iconObj.style.display = 'none' : '';
                }
                nameAlertMap.confirmHander = function (evt) {
                    cfg.confirmCb.call(cfg.calller);
                    cfg.closeAfterClick && _closeAlert();
                    evt.preventDefault();
                    evt.stopPropagation();
                }
                nameAlertMap.closeHander = function (evt) {
                    cfg.closeCb.call(cfg.calller);
                    cfg.closeAfterClick && _closeAlert();
                    evt.preventDefault();
                    evt.stopPropagation();
                }
                nameAlertMap.openHander = function (evt) {
                    cfg.openCb.call(cfg.calller);
                    evt && evt.preventDefault();
                    evt && evt.stopPropagation();
                }
                nameAlertMap.name = wndid;

                nameAlertMap.confirmObj = _ids.confirmObj;
                nameAlertMap.confirmCb = cfg.confirmCb;

                nameAlertMap.closeObj = _ids.closeObj;
                nameAlertMap.closeCb = cfg.closeCb;

                if(_isUseClick){
                    addEvent(_ids.confirmObj, 'click', nameAlertMap.confirmHander);
                    addEvent(_ids.closeObj, 'click', nameAlertMap.closeHander);
                }else{
                    addEvent(_ids.confirmObj, 'touchend', nameAlertMap.confirmHander);
                    addEvent(_ids.closeObj, 'touchend', nameAlertMap.closeHander);
                }


                addEvent(_ids.confirmObj, 'click', nameAlertMap.confirmHander);
                addEvent(_ids.closeObj, 'click', nameAlertMap.closeHander);

                layer.push(nameAlertMap);

                nameAlertMap.openHander.call(cfg.calller);
                var dialog = wrap.firstElementChild;
                // _ajustPos(dialog);

                var mainDom = document.querySelector('.wgui-alert-dialog__main');
                if(mainDom) {
                    var width = document.documentElement.clientWidth;
                    if(width < 360) {
                        mainDom.style.minWidth = width - 40 + 'px';
                        mainDom.style.maxWidth = width - 20 + 'px';
                    }
                }
            }

            /*
            *   开放第一个接口，
            *  弹出alert
            */
            ui.alert = _alert;
            /*
            *   开放第二个接口
            *   关闭当前栈顶的alert
            */
            ui.closeAlert = _closeAlert;
            exportData = ui;
        })({});
    })(window, document);
}else{
    exportData = {
        alert: function(){},
        closeAlert: function(){}
    };
}
export default exportData;